import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'lucide-react';
import Reveal from '../../components/Reveal';
import DashboardMock from './DashboardMock';

const CHECKLIST_KEYS = ['realtime', 'salesProfit', 'monthly', 'bestSeller'];

export default function ProgressShowcase() {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">{t('landing.progress.title')}</h2>
          <p className="text-gray-500 text-base leading-relaxed mb-8 max-w-md">{t('landing.progress.subtitle')}</p>
          <div className="space-y-4">
            {CHECKLIST_KEYS.map(k => (
              <div key={k} className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-violet-100 flex items-center justify-center flex-shrink-0">
                  <CheckCircle size={14} className="text-violet-600" />
                </div>
                <p className="text-sm font-medium text-gray-700">{t(`landing.progress.checklist.${k}`)}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={150}>
          <DashboardMock variant="progress" />
        </Reveal>
      </div>
    </section>
  );
}
